var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip")))
    ]),
    _vm.visible
      ? _c("div", { staticClass: "result-form-ai" }, [
          _c(
            "div",
            {
              staticClass: "content-container",
              style: { cursor: "pointer", width: "100%" }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _vm.showBookRecognitionResults
                  ? _c(
                      "div",
                      { staticClass: "column-header recognition-header" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_BookRecognitionResults")
                            )
                          )
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "toggle-btn",
                            on: {
                              click: function($event) {
                                _vm.showBookRecognitionResults = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PackUp")))]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "column-header confirmed-header" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ConfirmedBusinessData"))
                    )
                  ]),
                  !_vm.showBookRecognitionResults
                    ? _c(
                        "span",
                        {
                          staticClass: "toggle-btn",
                          on: {
                            click: function($event) {
                              _vm.showBookRecognitionResults = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExpandAll")))]
                      )
                    : _vm._e()
                ])
              ]),
              _vm.currentOcrRecognitionFields &&
              _vm.currentOcrRecognitionFields.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                      return _c("div", { key: item.code }, [
                        item.code === _vm.SystemConstants.MBL_NO.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.job.mbl,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "mbl", $$v)
                                          },
                                          expression: "job.mbl"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_HBL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.job.hbl,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "hbl", $$v)
                                          },
                                          expression: "job.hbl"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_OPERATE_TYPE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "operateType",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_ImportConstants$_cargoTypeAirInputList,
                                          "callback-method-type": "value",
                                          "default-value": _vm.job.operateType,
                                          "callback-params": {
                                            key: "operateType"
                                          },
                                          clearable: ""
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CUSTOMER_ID.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-company-select", {
                                        class:
                                          !_vm.job.customerId &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          "method-params": {
                                            customer: true,
                                            companyLob: "airImport",
                                            active: true
                                          },
                                          "default-value":
                                            _vm.job.customerId || "",
                                          placeholder:
                                            !_vm.job.customerId &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          change: function(p) {
                                            _vm.job.customerId = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value: _vm.job.shipper,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "shipper", $$v)
                                          },
                                          expression: "job.shipper"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value: _vm.job.consignee,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "consignee", $$v)
                                          },
                                          expression: "job.consignee"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value: _vm.job.notify,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "notify", $$v)
                                          },
                                          expression: "job.notify"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_ISSUED_BY.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].issuedBy,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "issuedBy",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].issuedBy"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_ACCOUNTING_INFO.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0]
                                              .accountingInfo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "accountingInfo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].accountingInfo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_CARRIER.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.carrierId &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "41",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "method-params": {
                                            airCmp: true,
                                            companyLob: "airImport",
                                            active: true
                                          },
                                          "default-value":
                                            _vm.job.carrierId || "",
                                          headers: [
                                            _vm.$t("Tool.ShortName"),
                                            _vm.$t("Partners.chineseName")
                                          ],
                                          fields: ["shortName", "chineseName"],
                                          placeholder:
                                            !_vm.job.carrierId &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.carrierId = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        on: {
                                          change: _vm.voyageFlightCheckHandler
                                        },
                                        model: {
                                          value: _vm.job.voyageFlight,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "voyageFlight",
                                              $$v
                                            )
                                          },
                                          expression: "job.voyageFlight"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_ETD.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          value: _vm.job.etd,
                                          type: "datetime",
                                          "value-format": "yyyy-MM-dd HH:mm",
                                          format: "yyyy-MM-dd HH:mm"
                                        },
                                        on: { input: _vm.etdChange }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.paymentTermMBL &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_PaymentTerm,
                                          filterable: "",
                                          clearable: "",
                                          "default-value":
                                            _vm.job.paymentTermMBL,
                                          placeholder:
                                            !_vm.job.paymentTermMBL &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.paymentTermMBL = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_INCO_TERM.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.incoTerm &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "incoTerm",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_IncoTerm,
                                          filterable: "",
                                          clearable: "",
                                          "default-value": _vm.job.incoTerm,
                                          placeholder:
                                            !_vm.job.incoTerm &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.incoTerm = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_SIGN_DATE_BL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          clearable: "",
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          format: "yyyy-MM-dd"
                                        },
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].signDateBL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "signDateBL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].signDateBL"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_SIGN_PLACE_BL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].signPlaceBL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "signPlaceBL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].signPlaceBL"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.loadingPortCode &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "englishName",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Airport,
                                          filterable: "",
                                          "default-value":
                                            _vm.job.loadingPortCode,
                                          "tag-name": "englishName",
                                          placeholder:
                                            !_vm.job.loadingPortCode &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.loadingPortCode = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.dischargingPortCode &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "dischargingPortCode",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Airport,
                                          filterable: "",
                                          "default-value":
                                            _vm.job.dischargingPortCode,
                                          placeholder:
                                            !_vm.job.dischargingPortCode &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.dischargingPortCode =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_QUANTITY_ACTUAL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input-number", {
                                        style: { textAlign: "left" },
                                        attrs: {
                                          controls: false,
                                          no: "quantityContract"
                                        },
                                        model: {
                                          value: _vm.job.quantityActual,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "quantityActual",
                                              $$v
                                            )
                                          },
                                          expression: "job.quantityActual"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_PACKING.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-packing-select", {
                                        class:
                                          !_vm.job.packing &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "packing",
                                          "default-value": _vm.job.packing,
                                          placeholder:
                                            !_vm.job.packing &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          change: function(p) {
                                            _vm.job.packing = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_WEIGHT_ACTUAL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input-number", {
                                        style: { textAlign: "left" },
                                        attrs: {
                                          precision: 3,
                                          controls: false,
                                          no: "weightContract"
                                        },
                                        model: {
                                          value: _vm.job.weightActual,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "weightActual",
                                              $$v
                                            )
                                          },
                                          expression: "job.weightActual"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_KGLB.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { no: "kglb" },
                                          model: {
                                            value: _vm.job.airCargoDoc[0].kglb,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job.airCargoDoc[0],
                                                "kglb",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "job.airCargoDoc[0].kglb"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "K", value: "K" }
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "L", value: "L" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CUBAGE_ACTUAL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input-number", {
                                        style: { textAlign: "left" },
                                        attrs: {
                                          precision: 3,
                                          controls: false,
                                          no: "cubageContract"
                                        },
                                        model: {
                                          value: _vm.job.cubageActual,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "cubageActual",
                                              $$v
                                            )
                                          },
                                          expression: "job.cubageActual"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_MARK.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          rows: 6,
                                          type: "textarea",
                                          no: "mark"
                                        },
                                        model: {
                                          value: _vm.job.mark,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "mark", $$v)
                                          },
                                          expression: "job.mark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          rows: 6,
                                          type: "textarea",
                                          no: "cargoEnglishName"
                                        },
                                        model: {
                                          value: _vm.job.cargoEnglishName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "cargoEnglishName",
                                              $$v
                                            )
                                          },
                                          expression: "job.cargoEnglishName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CARRIAGE_DV.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].carriageDv,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "carriageDv",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].carriageDv"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_DVFOR_CUSTOMS.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].dvForCustoms,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "dvForCustoms",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].dvForCustoms"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_RATE_CLASS.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { no: "rateClass" },
                                          model: {
                                            value:
                                              _vm.job.airCargoDoc[0].rateClass,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job.airCargoDoc[0],
                                                "rateClass",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "job.airCargoDoc[0].rateClass"
                                          }
                                        },
                                        _vm._l(
                                          _vm.AirExportConstants.RATE_CLASSES,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item,
                                              attrs: {
                                                label: item,
                                                value: item
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CHARGEWEIGHT.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "chargeWeight",
                                          precision: 3,
                                          min: 0
                                        },
                                        on: {
                                          valCallBack: function(val) {
                                            _vm.job.chargeWeight = val
                                          }
                                        },
                                        model: {
                                          value: _vm.job.chargeWeight,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "chargeWeight",
                                              $$v
                                            )
                                          },
                                          expression: "job.chargeWeight"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_RATE_CHARGE.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].rateCharge,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "rateCharge",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].rateCharge"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_C_TOTAL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.job.airCargoDoc[0].cTotal,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "cTotal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].cTotal"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_DIMENSION.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          rows: 6,
                                          type: "textarea",
                                          no: "dimension"
                                        },
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0].dimension,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "dimension",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].dimension"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_CURRENCY.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("cargo-advance-select", {
                                        class:
                                          !_vm.job.airCargoDoc[0].currency &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        attrs: {
                                          no: "currency",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Currency,
                                          filterable: "",
                                          "default-value":
                                            _vm.job.airCargoDoc[0].currency,
                                          placeholder:
                                            !_vm.job.airCargoDoc[0].currency &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.job.airCargoDoc[0].currency =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_WT_VAL.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { no: "wtVal" },
                                          model: {
                                            value: _vm.job.airCargoDoc[0].wtVal,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job.airCargoDoc[0],
                                                "wtVal",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "job.airCargoDoc[0].wtVal"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "PP", value: "PP" }
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "CC", value: "CC" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code ===
                        _vm.SystemConstants.OCR_FIELD_SIGN_BY_SHIPPER.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "field-value" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.job.airCargoDoc[0]
                                              .signByShipper,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job.airCargoDoc[0],
                                              "signByShipper",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job.airCargoDoc[0].signByShipper"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        item.code === _vm.SystemConstants.OCR_FIELD_REMARKS.code
                          ? _c(
                              "div",
                              {
                                staticClass: "row",
                                on: {
                                  click: function($event) {
                                    return _vm.handleFocus(item.code)
                                  }
                                }
                              },
                              [
                                _vm.showBookRecognitionResults
                                  ? _c("div", { staticClass: "item2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "field-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.OcrUtils.getOcrFieldLabel(
                                                item.code,
                                                _vm.useCase
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value field-value-textarea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.resultJson[item.code])
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "item3" }, [
                                  _c("div", { staticClass: "field-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "field-value field-value-textarea"
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          rows: 6,
                                          type: "textarea",
                                          no: "remarks"
                                        },
                                        model: {
                                          value: _vm.job.remarks,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "remarks", $$v)
                                          },
                                          expression: "job.remarks"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }